import { getButtonStyle } from './Button.styles.ts'
import type { ButtonProps } from './Button.types.ts'

export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled,
  children,
  ...rest
}: ButtonProps) {
  const isDisabled = disabled || loading

  return (
    <button
      style={getButtonStyle(variant, size, isDisabled)}
      disabled={isDisabled}
      {...rest}
    >
      {loading ? 'Loading...' : children}
    </button>
  )
}
